/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Contentplaceholder1Inputs */

const he_posts_contentplaceholder1 = /** @type {(inputs: Posts_Contentplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כתוב את תוכן הפוסט שלך...`)
};

const en_posts_contentplaceholder1 = /** @type {(inputs: Posts_Contentplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your post content...`)
};

/**
* | output |
* | --- |
* | "Write your post content..." |
*
* @param {Posts_Contentplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_contentplaceholder1 = /** @type {((inputs?: Posts_Contentplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Contentplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_contentplaceholder1(inputs)
	return en_posts_contentplaceholder1(inputs)
});
export { posts_contentplaceholder1 as "posts_contentPlaceholder" }